<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-8 no-padding">
       
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Submit new discussion</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                <div class="col-md-12 col-sm-12 ">

                    <div class="row small-section-content" style="margin-bottom:30px">
                        <div class="col-xl-12 text-center empty">
                            <p style="text-align: left;">
                                Get the discussion started with a question, or idea. The discussion is public all the members can see and contribute on it.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-12 col-sm-12 col-xs-12 b20-margin no-padding r20-padding l20-padding t30-padding b20-padding myG-box">
                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding ">

                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="selectCategoryOption($event)">

                                        <option *ngFor="let category of discussionCategories" [value]="category.code">
                                            {{ category.name}}
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Post to</label>
                                </div>
                            </div>

                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <input [(ngModel)]="discussion" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Subject</label>
                                </div>
                            </div>

                            

                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <!--<span class="p-fluid">-->
                                    <!--<input type="text" class="form-control" id="floatingSelect">-->
                                    <!--<p-autoComplete placeholder="select discussion tag..." id="floatingSelect" [(ngModel)]="selectedTags" [suggestions]="filteredTags" (completeMethod)="filterTag($event)" field="tagName" [multiple]="true">
                                        </p-autoComplete>

                                    </span>-->
                                    
                                    <tag-input [(ngModel)]="selectedTags"
                                               [onlyFromAutocomplete]="true">
                                        <tag-input-dropdown [showDropdownIfEmpty]="true"
                                                            [focusFirstElement]="true"
                                                            [displayBy]="'tagName'"
                                                            [identifyBy]="'tagId'"
                                                            [autocompleteItems]="tags">
                                            <ng-template let-item="item" let-index="index">
                                                {{ item.tagName }}
                                            </ng-template>
                                        </tag-input-dropdown>
                                    </tag-input>

                                </div>
                            </div>

                            <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">

                                <div class="form-floating">
                                    <!--<textarea style="height:150px" class="form-control" placeholder="Leave your description here..." id="floatingTextareaDescription"></textarea>-->
                                    <quill-editor [(ngModel)]="details" [styles]="{height: '400px'}" placeholder="Leave your description here..."></quill-editor>
                                    <!--<label for="floatingTextareaDescription">Discussion Details</label>-->
                                </div>

                            </div>
                            <!--<div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
      <div class="form-floating">
        <span class="p-fluid">
          <label for="floatingSelect">Tags</label>
          <p-autoComplete id="floatingSelect" [(ngModel)]="selectedCountries" [suggestions]="filteredCountries" (completeMethod)="filterCountry($event)" field="name" [multiple]="true">
          </p-autoComplete>

        </span>
      </div>
    </div>-->
                            <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="text-align:right">
                                <button (click)="onSubmitDiscussionBoard()" style="" class="btn mygistec-main-btn">SUBMIT</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    </div>
    <div class="col-md-4" style="padding-right: 0px; padding-left: 30px;">
        <app-discussions-active-users></app-discussions-active-users>
    </div>
</div>
